import { left, map } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/pipeable';
import { zip } from 'lodash';
import { Vector3D } from '../Vector';
export class Position3D {
    static fromTuple = ([x, y, z]) => new Position3D(x, y, z);
    static fromVector3D = (vector3d) => new Position3D(...vector3d.value());
    static fromMatrix(matrix) {
        if (matrix.rows() === 1 && matrix.columns() === 3) {
            return pipe(matrix.row(0), map(pos => pos.value()), map(([x, y, z]) => new Position3D(x, y, z)));
        }
        else if (matrix.columns() === 1 && matrix.rows() === 3) {
            return pipe(matrix.column(0), map(pos => pos.value()), map(([x, y, z]) => new Position3D(x, y, z)));
        }
        else {
            return left('[Pos3D]: Validation Error - unable to construct Pos3D from Matrix');
        }
    }
    _position;
    constructor(x, y, z) {
        this._position = [x, y, z];
    }
    x() {
        return this._position[0];
    }
    y() {
        return this._position[1];
    }
    z() {
        return this._position[2];
    }
    value() {
        return this._position;
    }
    maximum(right) {
        const [x, y, z] = zip(this.value(), right.value()).map(([l, r]) => Math.max(l, r));
        return new Position3D(x, y, z);
    }
    minimum(right) {
        const [x, y, z] = zip(this.value(), right.value()).map(([l, r]) => Math.min(l, r));
        return new Position3D(x, y, z);
    }
    translate(vector) {
        const [x, y, z] = vector.value();
        return new Position3D(this.x() + x, this.y() + y, this.z() + z);
    }
    subtract(right) {
        const [x, y, z] = this.value();
        const [x1, y1, z1] = right.value();
        return new Vector3D([x - x1, y - y1, z - z1]);
    }
    equal(right) {
        return (this.x() === right.x() &&
            this.y() === right.y() &&
            this.z() === right.z());
    }
    greaterThan(right) {
        return (this.x() > right.x() && this.y() > right.y() && this.z() > right.z());
    }
    toString() {
        return `Pos(${this.x()}, ${this.y()}, ${this.z()})`;
    }
}
//# sourceMappingURL=Position3D.js.map